export default class AgeGroupFilter {
  AgeGroupFilter() {
    return {
      // default: 'Age group',
      '0-2': '0-2',
      '2-3': '2-3',
      '3-5': '3-5',
      '5-12': '5-12',
    };
  }
}
